import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Filter } from '../../components/lister/filters/Filter';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { makeGetContentFilters, makeGetContentTotalElements } from '../../redux/content/selectors/ContentSelectors';
import { filterActions } from '../../redux/filter/actions/FilterActions.creators';
export const FilterContainer = () => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const dispatch = useDispatch();
    const filters = useSelector(makeGetContentFilters());
    const totalItems = useSelector(makeGetContentTotalElements());
    const getContentFilters = (contentFilters) => (contentFilters !== null && contentFilters !== void 0 ? contentFilters : []).map((filter) => (Object.assign(Object.assign({}, filter), { name: t(filter.name) })));
    const onFilterItemChange = (toggledFilter) => dispatch(filterActions.updateFilters(toggledFilter));
    const removeAllFilters = () => dispatch(filterActions.removeAllFilters());
    const contentFilters = useMemo(() => getContentFilters(filters), [filters]);
    return (_jsx(Filter, { isContentTileLister: true, filters: contentFilters, removeAllFilters: removeAllFilters, onFilterItemChange: onFilterItemChange, itemCount: totalItems }));
};
